import {analyticsLogEvent} from '../api'

const eventName = 'custom_event'

interface Parameters {
    eventAction: 'header' | 'footer'
    eventLabel: string
    menuHierarchy: number
}

/**
 * Tracks a click on a cross navigation category item.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.eventAction - The position of the cross navigation element.
 * @param {string} params.eventLabel - The id of the clicked category.
 * @param {string} params.menuHierarchy - The position of the clicked category.
 */
export function analyticsEventCrossCategoryNavigationClick({eventAction, eventLabel, menuHierarchy}: Parameters): void {
    const eventDetails = {
        eventCategory: 'cross navigation',
        eventAction,
        eventLabel,
        menu_hierarchy: menuHierarchy.toString(),
        menu_template: 'cross navigation',
    }

    analyticsLogEvent(eventName, eventDetails)
}
